import { render, staticRenderFns } from "./favList.vue?vue&type=template&id=cea3c6e6&scoped=true"
import script from "./favList.vue?vue&type=script&lang=js"
export * from "./favList.vue?vue&type=script&lang=js"
import style0 from "./favList.vue?vue&type=style&index=0&id=cea3c6e6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cea3c6e6",
  null
  
)

export default component.exports